import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { format } from 'date-fns';
import { formatCompanyName } from '../services/websiteAnalyzer';

const ResultsTable = ({ results }) => {
  const statusClass = (score) => {
    if (score >= 7) return 'status-confirmed';
    if (score >= 5) return 'status-pending';
    return 'status-low';
  };

  const getStatusText = (score) => {
    if (score >= 7) return 'High Potential';
    if (score >= 5) return 'Medium';
    return 'Low Priority';
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString || Date.now());
      return format(date, 'dd MMM yyyy');
    } catch (e) {
      return 'N/A';
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="results-table-container"
    >
      <table className="subscriptions-table">
        <thead>
          <tr>
            <th>Company</th>
            <th>Analysis Date</th>
            <th>Fit Score</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {results.map((result, index) => {
            // Generate an initial for the avatar
            const companyName = formatCompanyName(result.company, result.url);
            const initial = companyName.charAt(0).toUpperCase();
            
            return (
              <tr key={result.url || result.id || `result-${index}`}>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                    <div
                      className="user-avatar-small"
                      style={{ backgroundColor: ['#818cf8', '#f472b6', '#fb923c'][index % 3] }}
                    >
                      {initial}
                    </div>
                    <div>
                      <div className="company-name">{companyName}</div>
                      <div className="website-url" title={result.url}>
                        {result.url ? new URL(result.url).hostname : 'N/A'}
                      </div>
                    </div>
                  </div>
                </td>
                <td>{formatDate(result.analyzedAt)}</td>
                <td>{result.fitScore || 'N/A'}</td>
                <td>
                  <span className={`status-badge ${statusClass(result.fitScore)}`}>
                    {getStatusText(result.fitScore)}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      
      <style jsx>{`
        .company-name {
          font-weight: 500;
          font-size: 0.875rem;
        }
        
        .website-url {
          font-size: 0.75rem;
          color: var(--text-light);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 180px;
        }
      `}</style>
    </motion.div>
  );
};

export default ResultsTable;